module.exports = __webpack_public_path__ + "img/banca-por-internet.c5e47958.svg";